import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, NgModel, ValidationErrors, Validator} from "@angular/forms";

@Directive({
  selector: '[brtRepeatFieldValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting:RepeatFieldValidatorDirective,
    multi: true
  }]
})
export class RepeatFieldValidatorDirective implements Validator {

  @Input('brtRepeatFieldValidator') compare!: NgModel[][];
  constructor() {
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.compare || !this.compare.length) {
      return null;
    }

    for (const group of this.compare) {
      if (!group || group.length < 2) {
        continue;
      }

      const original = group[0];
      if (!original || !original.control) {
        continue;
      }

      const originalValue = original.control.value;
      for (let i = 1; i < group.length; i++) {
        const field = group[i];
        if (!field || !field.control) {
          continue;
        }

        if (field.control.value !== originalValue) {
          field.control.setErrors({ ...field.control.errors, repeatFieldMismatch: true });
        } else {
          if (field.control.errors) {
            const errors = { ...field.control.errors };
            delete errors['repeatFieldMismatch'];
            field.control.setErrors(Object.keys(errors).length ? errors : null);
          }
        }
      }
    }

    return null;
  }

}
